import { useNavigate, useLocation } from "react-router-dom";
import Menu from "./menu.json";
import "./style.css";
import {
  MdImage
  , MdInfo,
  MdFactCheck,
  MdCategory, MdContacts,
  MdEvent, MdMenuOpen, MdShoppingCart,
  MdRateReview, MdAdminPanelSettings,
  MdSchedule, MdOutlineMenu, MdPerson,
  MdLocalOffer
} from "react-icons/md";
import { MdDashboard } from "react-icons/md";


import React from "react";

// Helper function to render React icons safely with React 19
const renderIcon = (IconComponent: any, props: any = {}) => {
  return React.createElement(IconComponent as React.ComponentType, props);
};

const iconMap: any = {
  admin_panel_settings: MdAdminPanelSettings,
  dashboard: MdDashboard,
  image: MdImage,
  info: MdInfo,
  fact_check: MdFactCheck,
  category: MdCategory,
  shopping_cart: MdShoppingCart,
  rate_review: MdRateReview,
  schedule: MdSchedule,
  contacts: MdContacts,
  event: MdEvent,
  profile: MdPerson,
  offer: MdLocalOffer,
};

function SideBaruser(props: any) {
  const navigate = useNavigate();
  const location = useLocation();

  // State to track which main menu items have an open sub-menu
  const [openSubMenus, setOpenSubMenus] = React.useState<{
    [key: string]: boolean;
  }>({});

  const toggleSubMenu = (id: string) => {
    setOpenSubMenus((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the visibility of the sub-menu for the clicked item
    }));
  };

  return (
    <>
      <div className="mains">
        <div className="toggleButton">
          {props?.collapsed ? (
            // Use the renderIcon helper function instead of direct component usage
            renderIcon(MdOutlineMenu, {
              size: 30,
              color: "#fff",
              onClick: () => props.doCollapse(!props.collapsed)
            })
          ) : (
            // Use the renderIcon helper function instead of direct component usage
            renderIcon(MdMenuOpen, {
              size: 30,
              color: "#fff",
              onClick: () => props.doCollapse(!props.collapsed)
            })
          )}
        </div>
        <div
          className="sideBar-Box"
          style={{ width: props?.collapsed ? 80 : 250, height: "100vh" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              overflowY: "auto",
              height: "100%",
            }}
          >
            {Menu?.map((item: any) => {
              const IconComponent = iconMap[item.icon];

              return (
                <div
                  key={item?.id}
                  className={
                    location.pathname === item?.navigate
                      ? "sideBar-itemadmin  active"
                      : "sideBar-itemadmin"
                  }
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "stretch",
                    // padding: "10px 15px",
                    cursor: "pointer",
                    transition: "background 0.3s",
                  }}
                >
                  {/* Render Main Menu Item */}
                  <div
                    onClick={() => {
                      if (item?.subMenu) {
                        // If it has a sub-menu, toggle the visibility
                        toggleSubMenu(item?.id);
                      } else {
                        // If no sub-menu, navigate directly
                        navigate(item?.navigate);
                      }
                    }}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    {/* Render Icon: Check if it's an image or component */}
                    {typeof IconComponent === "string" ? (
                      <img
                        src={IconComponent}
                        alt={item.title}
                        style={{ width: 20, height: 20 }}
                      />
                    ) : (
                      IconComponent && (
                        // Use renderIcon for react-icons
                        IconComponent.type?.displayName?.startsWith("Md")
                          ? renderIcon(IconComponent, { size: 20, color: "#fff" })
                          : <IconComponent size={20} color="#fff" />
                      )
                    )}
                    {!props?.collapsed && (
                      <>
                        <div style={{ marginLeft: 20 }} />
                        <div>{item?.title}</div>
                      </>
                    )}
                  </div>

                  {/* Render Sub-menu if present and open */}
                  {item?.subMenu &&
                    openSubMenus[item?.id] &&
                    !props?.collapsed && (
                      <div style={{ marginLeft: 20 }}>
                        {item?.subMenu.map((subItem: any) => {
                          const SubIconComponent = iconMap[subItem.icon];
                          return (
                            <div
                              key={subItem?.id}
                              onClick={() => {
                                // Navigate to sub-menu item
                                navigate(subItem?.navigate);
                              }}
                              className={
                                location.pathname === subItem?.navigate
                                  ? "sideBar-itemadmin active"
                                  : "sideBar-itemadmin"
                              }
                              style={{
                                display: "flex",
                                alignItems: "center",
                                // padding: "8px 15px",
                                cursor: "pointer",
                                transition: "background 0.3s",
                              }}
                            >
                              {typeof SubIconComponent === "string" ? (
                                <img
                                  src={SubIconComponent}
                                  alt={subItem.title}
                                  style={{ width: 20, height: 20 }}
                                />
                              ) : (
                                SubIconComponent && (
                                  // Use renderIcon for react-icons
                                  SubIconComponent.type?.displayName?.startsWith("Md")
                                    ? renderIcon(SubIconComponent, { size: 20, color: "#fff" })
                                    : <SubIconComponent size={20} color="#fff" />
                                )
                              )}
                              {!props?.collapsed && (
                                <>
                                  <div style={{ marginLeft: 20 }} />
                                  <div>{subItem?.title}</div>
                                </>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default SideBaruser;